module.exports = __webpack_public_path__ + "img/icons B_4.88cd445e.png";